import { render, staticRenderFns } from "./3.vue?vue&type=template&id=dc934f34&scoped=true"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=dc934f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc934f34",
  null
  
)

export default component.exports